// extracted by mini-css-extract-plugin
export default {"root":"F4eOowNKiOAiVU7kODi3","items":"MDvRwrfmGshMU8I9WPw4"};